import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import Geosuggest from '@ubilabs/react-geosuggest';
import './input.scss';
import { updateFilter } from '@/stores/slices/filterSlice';
import { getGmapsApiReady } from '@/stores/slices/mapModelSlice';
import {
	setOneProfileAddress,
	setOneProfileCoords,
} from '@/stores/slices/oneProfileSlice';

const AddressInput = ({ clazz, placeholder, name, value, bounds }) => {
	const dispatch = useDispatch();
	const apiReady = useSelector(getGmapsApiReady);
	const [renderElem, setRenderElem] = useState(false);

	useEffect(() => {
		if (apiReady) {
			setRenderElem(true);
		}
	}, [apiReady]);

	useEffect(() => {
		if (bounds?.lat) {
			setRenderElem(true);
		}
	}, [bounds]);

	const onSuggestSelect = (suggest) => {
		if (suggest) {
			if (name === 'location') {
				dispatch(
					updateFilter({
						radius: {
							value: [suggest.description],
							latitude: suggest.location.lat,
							longitude: suggest.location.lng,
						},
					}),
				);
			}
			if (name === 'location-create') {
				dispatch(setOneProfileAddress(suggest.description));
				dispatch(
					setOneProfileCoords({
						latitude: suggest.location.lat,
						longitude: suggest.location.lng,
					}),
				);
			}
		}
	};

	return (
		renderElem && (
			<Geosuggest
				initialValue={value.length > 0 ? value[0] : ''}
				inputClassName={`input ${clazz ? clazz : ''}`}
				onSuggestSelect={onSuggestSelect}
				placeholder={placeholder}
				queryDelay={100}
				location={bounds}
				radius="20"
			/>
		)
	);
};

const Input = (props) => {
	const {
		type,
		placeholder,
		value,
		setValue,
		id,
		clazz,
		autocomplete = 'off',
		name,
		onClose = '',
		valueFromSearch = '',
		bounds,
	} = props;

	const [inputValue, setInputValue] = useState(value);

	const handleReset = () => {
		setInputValue('');
		setValue('');
	};

	useEffect(() => {
		if (onClose) {
			setInputValue('');
		}
	}, [onClose]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	const handleChange = (e) => {
		const value = e.target.value;
		setInputValue(value);
		setValue(value);
	};

	if (name === 'location' || name === 'location-create') {
		return (
			<AddressInput
				bounds={bounds}
				placeholder={placeholder}
				clazz={clazz}
				name={name}
				value={valueFromSearch}
			/>
		);
	}

	return (
		<>
			<input
				autoComplete={autocomplete}
				className={`input ${clazz ? clazz : ''}`}
				type={type}
				name={name}
				value={inputValue}
				placeholder={placeholder ? placeholder : ''}
				onChange={handleChange}
				id={id}
			/>
			{inputValue && (
				<i
					className="icon icon-m icon--close"
					onClick={handleReset}
				></i>
			)}
		</>
	);
};

Input.propTypes = {
	type: PropTypes.any,
	placeholder: PropTypes.string,
	value: PropTypes.string,
	setValue: PropTypes.func,
};

export default Input;
